export const UMB_IS_ROUTABLE_CONTEXT_CONDITION_ALIAS = 'Umb.Condition.IsRoutableContext';
